import { __awaiter } from '../../_virtual/_tslib.js';
import { useQuery } from 'react-query';
import { toast } from '../../components/toast/toast.js';
import API from '../const.js';
import { QueryNames } from './queryNames.js';

function useValidateToken({ token, refetchInterval, enabled }) {
    const { data } = useQuery([QueryNames.validateToken, token], () => {
        if (!token) {
            return false;
        }
        return fetch(`${API.VALIDATE_TOKEN}?t=Bearer ${token}`).then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 200) {
                return true;
            }
            else {
                if (res.status === 401) {
                    // Unauthorized
                    toast.dismiss();
                    yield res.json();
                    // toast.error(message ? message : "Session Expired");
                }
                return false;
            }
        }));
    }, { refetchInterval, enabled, refetchOnWindowFocus: false });
    return { data };
}

export { useValidateToken };
//# sourceMappingURL=useAuthService.js.map
